module.exports = __webpack_public_path__ + "static/media/collagen360ºEyeContour.74897b71.png";